import { render, staticRenderFns } from "./SurveyReview.vue?vue&type=template&id=6fb425f8&scoped=true"
import script from "./SurveyReview.vue?vue&type=script&lang=js"
export * from "./SurveyReview.vue?vue&type=script&lang=js"
import style0 from "./SurveyReview.vue?vue&type=style&index=0&id=6fb425f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb425f8",
  null
  
)

export default component.exports